import PrimaryDetails from "../../../../worklists/singleOrder/components/primaryDetails/primaryDetails";
import PatientIdentifiers from "../patientIdentifiers/patientIdentifiers";

const PatientPrimaryDetails = (props) => {
  return (
    <div className="primary-patient-details--container">
      <PatientIdentifiers patientIdentifierData={props.patientIdentifierData} />
      <PrimaryDetails details={props.primaryDetails} />
    </div>
  );
};

export default PatientPrimaryDetails;
